import Content from 'components/Content'

import { Container } from './style'

export default function App() {
  return (
    <Container>
      <Content />
    </Container>
  )
}
